// Um lugar só para os breakpoints: o Tailwind e o tema do MUI leem daqui.
export const SCREENS = {
  sm: '480px',
  md: '960px',
  lg: '1280px',
  xl: '1440px',
  '2xl': '1640px',
  '3xl': '1900px',
} as const
